import { useTranslation } from 'react-i18next'
import * as Fragments from '../../../../../application/components/building_blocks/messages/message_details/content/fragments'

export function MobileViewAktenFolders() {
    const {t} = useTranslation()
    return <div style={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
     }}>
        <Fragments.ParNoContent>{t('No folders have been created yet.')}</Fragments.ParNoContent>        
    </div>
}